'use client';
import React from 'react';
import AppButton from '@/src/app/components/Button/AppButton';
import { ButtonSize } from '@/src/app/components/Button/Button';
import { IconName } from '@/src/app/components/Icon/types';

function ScrollToTopButton() {
  function onClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <AppButton
      icon={IconName.ARROW_BACK_IOS_NEW}
      className="rotate-90"
      priority
      size={ButtonSize.LARGE}
      onClick={onClick}
    />
  );
}

export default ScrollToTopButton;
